module.exports = __webpack_public_path__ + "img/cardbg-1.b74457ff.jpeg";